import React from "react";

const ManageCompanies = () => {
  return (
    <div>
      <h2>List Company</h2>
    </div>
  );
};

export default ManageCompanies;
